import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lp-twofive-twosix-odd',
  templateUrl: './lp-twofive-twosix-odd.component.html',
  styleUrls: ['./lp-twofive-twosix-odd.component.scss']
})
export class LpTwofiveTwosixOddComponent implements OnInit {
pdfSrc: string[] = [
    'https://drive.google.com/file/d/11T-cX5csQfWf_57CDZpYBf2UhoMNdLDL/preview',
    'https://drive.google.com/file/d/1bVh0NdnaGsNvUu5qQ0NUffpLNcAJ0inE/preview',
    'https://drive.google.com/file/d/13EjRY0wHV_ODwMJUTTBrFQKSpamPfUVL/preview',
    'https://drive.google.com/file/d/13yqJC8ntWg89e1UI9tIWLttsM2PfYdU3/preview',
    'https://drive.google.com/file/d/1Asxzwl_5PoR822P3xWI8l61zII-1RuXg/preview',
    'https://drive.google.com/file/d/1H33eupOJ4h5VG5GAqzICdQXI_bTOsVmD/preview',
    'https://drive.google.com/file/d/1L1ay_JyHmOxWtTJdvkzBNwGWSDYEb5lO/preview',
    'https://drive.google.com/file/d/1RLRmHkGGPB2w7j1-41xzw6-GsaSX6WIE/preview',
    'https://drive.google.com/file/d/1WmXCc9Uh_miTl8VYRBaGEfLGzHky531k/preview',
    'https://drive.google.com/file/d/1i0voPIqEkKDRFGsbUKYxi76Lw8bgpEFx/preview',
    'https://drive.google.com/file/d/1i0voPIqEkKDRFGsbUKYxi76Lw8bgpEFx/preview',
    'https://drive.google.com/file/d/13QokFP10OwYJ3rdF_AK4kNguraIAO8y-/preview',
    'https://drive.google.com/file/d/1O9sNsc6-lxoXWXCag2Jb6H7uKv2bV5TV/preview',
    'https://drive.google.com/file/d/1NIbbgeyrf5JVDVMr0_igdBekXisEcqGF/preview',
    'https://drive.google.com/file/d/1GSiXWbU83_n6f_hR9TlXu_hIvMWZtJ7O/preview',
    'https://drive.google.com/file/d/1HzC7Wl1_qt4wfF_dFN-UtoN2LGc24xLl/preview',
    'https://drive.google.com/file/d/1bNwWaQK1JufdYEaMYl10n4QLXoOf8CUB/preview',
    'https://drive.google.com/file/d/1mwmVt5IN1wWEylDY7qIghrUjFrfDx5Qk/preview',
    'https://drive.google.com/file/d/1OmynXoK1Du4uNte-W1Cf3qW6FAc9HKnV/preview',
    'https://drive.google.com/file/d/1mqmTItX6_JCOh7HMMg49-aSjBwaaiCC6/preview',
    'https://drive.google.com/file/d/1hC4vdWW3fUjc8lIfsSUsyt4z7YRAA_aJ/preview',
    'https://drive.google.com/file/d/1q9FzS55ZwIlnpTQKOEQaF9lMpR_g7gOH/preview',
    'https://drive.google.com/file/d/17K5AUk9wmHB3Hqp-YUKjNun7H7Z_yhbo/preview',
  ];

  departments = [
    { id: '1', name: 'DEPARTMENT OF ECONOMICS' },
    { id: '2', name: 'DEPARTMENT OF GEOGRAPHY' },
    { id: '3', name: 'DEPARTMENT OF PUBLIC ADMINISTRATION' },
    { id: '4', name: 'DEPARTMENT OF POLITICAL SCIENCE' },
    { id: '5', name: 'DEPARTMENT OF MATHEMATICS' },
    { id: '6', name: 'DEPARTMENT OF ZOOLOGY' },
    { id: '7', name: 'DEPARTMENT OF SANSKRIT' },
    { id: '8', name: 'DEPARTMENT OF HINDI' },
    { id: '9', name: 'DEPARTMENT OF B.P.Ed.' },
    { id: '10', name: 'DEPARTMENT OF BCA' },
    { id: '11', name: 'DEPARTMENT OF BOTANY' },
    { id: '12', name: 'DEPARTMENT OF COMMERCE' },
    { id: '13', name: 'DEPARTMENT OF PHYSICS' },
    { id: '14', name: 'DEPARTMENT OF SOCIAL WORK' },
    { id: '15', name: 'DEPARTMENT OF MUSIC' },
    { id: '16', name: 'DEPARTMENT OF PUNJABI' },
    { id: '17', name: 'DEPARTMENT OF HISTORY' },
    { id: '18', name: 'DEPARTMENT OF CHEMISTRY' },
    { id: '19', name: 'DEPARTMENT OF BPS' },
    { id: '20', name: 'DEPARTMENT OF BIOTECHNOLOGY' },
    { id: '21', name: 'DEPARTMENT OF SPORTS' },
    { id: '22', name: 'DEPARTMENT OF YOGA' },
    { id: '23', name: 'DEPARTMENT OF ENGLISH' },
  ];

  src: string;
  isLoading = true;
  activeDepartment: string = '1';
  constructor() {}

  ngOnInit(): void {
    this.changeRoute('1');
  }
  changeRoute(year: string) {
    this.isLoading = true;
    this.activeDepartment = year;
    this.src = this.pdfSrc[parseInt(year) - 1] || ''; // Set the corresponding PDF source
  }
}
